<template>
  <section
    class="root h-screen w-screen lg:rounded-2xl bg-white lg:border-gray-400 lg:border-4 relative overflow-hidden"
  >
    <slot />
    <footer
      class="!hidden !lg:flex bg-gray-400 absolute bottom-0 h-7 left-0 right-0 text-gray-300 px-16 py-2 flex-row justify-between"
    >
      <div class="flex flex-row gap-8">
        <a href="tel:+79407092222" class="my-auto p-0 text-xs"> +7 940 709 22 22 </a>
        <a href="#" class="my-auto p-0 text-xs"> Справка </a>
      </div>
      <div class="flex flex-row gap-2">
        <p class="my-auto p-0 text-xs">
          2024
        </p>
        <p class="my-auto p-0 text-xs">
          ООО «ticketme Билеты Абхазии»
        </p>
      </div>
    </footer>
  </section>
</template>

<script setup>
onMounted(() => {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  })
})
</script>

<style scoped>
.root {
  height: 100vh; /* Use vh as a fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
}
</style>
